function selectText(node) {
	nodeClass = node.classList[2];
	node = document.querySelector('.' + nodeClass);

	if (document.body.createTextRange) {
		const range = document.body.createTextRange();
		range.moveToElementText(node);
		range.select();
	} else if (window.getSelection) {
		const selection = window.getSelection();
		const range = document.createRange();
		range.selectNodeContents(node);
		selection.removeAllRanges();
		selection.addRange(range);
	}
}

let count = 0;
document.querySelectorAll('.click-me').forEach((item) => {
	item.classList.add('click-me-' + count)
	className = item.className
	item.addEventListener('click', () => selectText(item));
	count++;
});